import React from "react";
import ApiResponseViewer from "../ApiResponseViewer";
const res = `{
    "webhookId": 1,
    "webhookUrl": "https://test.aspx",
    "userName": "Neeraj@example.com",
    "isActive": true
}`.trim();
const WebhookEntity = () => {
  return (
    <div style={{ display: "flex", margin: "6px" }}>
      <div style={{ flex: "1" }}>
        <h3 style={{ margin: "16px" }}>Webhook Entity</h3>
        <div></div>
      </div>
      <div style={{ flex: "1" }}>
        <ApiResponseViewer response={res} />
      </div>
    </div>
  );
};

const Row = ({ first, second }) => {
  return (
    <div
      style={{
        display: "flex",
        border: "1px solid #DDDDDD",
        borderRadius: "4px",
        padding: "6px",
      }}
    >
      <div style={{ flex: "1" }}>{first}</div>
      <div style={{ flex: "2" }}>{second}</div>
    </div>
  );
};

export default WebhookEntity;
